import React, { Suspense } from 'react';

import { PageSubtitle, TableSkeleton } from '@eluve/components';
import { FilterableAppointmentsTable } from '@eluve/frontend-feature-appointment';

export const AdminAppointmentsDash: React.FC = () => {
  return (
    <div>
      <PageSubtitle> Appointments</PageSubtitle>
      <Suspense fallback={<TableSkeleton numRows={20} />}>
        <FilterableAppointmentsTable isAdmin enableRowSelection />
      </Suspense>
    </div>
  );
};
